<script>
import ModalSendMail from "../components/ModalSendMail.vue";

export default {
    name: "ModalVendorTransactions",
    components: {ModalSendMail},
    data() {
        return {
            visible: false,
            transactions: [],
            loading: false,
            transaction: {},
            vendorid: 0
        }
    },
    methods: {
        open(vendorid) {
            this.visible = true;
            this.vendorid = vendorid;
            this.fetchTransactions();
        },
        close() {
            this.visible = false;
        },
        fetchTransactions() {
            this.loading = true;
            this.$api.get('/buildium/vendors/' + this.vendorid + '/transactions').then(response => {
                this.transactions = response.data;
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                this.loading = false;
            });
        },
        showSendMail(transaction) {
            this.transaction = transaction;
            this.$refs.sendMail.open();
        },
        onSendMail(options) {
            const {vendorid} = this;
            this.$api.post(`/buildium/vendors/${vendorid}/sendtransaction`, {
                transaction: this.transaction,
                options
            }).then(() => {
                this.$message.success('Mail Sent');
                this.fetchTransactions();
            }).catch(reason => {
                this.$message.error(reason.message);
            }).finally(() => {
                //this.$refs.sendMail.close();
            });
        }
    }
}
</script>

<template>
    <el-dialog
        width="85%"
        title="Transactions"
        closeable
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :modal-append-to-body="true"
        :append-to-body="true"
        @close="close"
    >
        <el-table :data="transactions" v-loading="loading">
            <el-table-column prop="Memo" label="Memo"/>
            <el-table-column prop="ReferenceNumber" label="Reference Number" width="200"></el-table-column>
            <el-table-column prop="TotalAmount" label="Total Amount" width="160"></el-table-column>
            <el-table-column prop="TransactionType" label="Transaction Type" width="200"></el-table-column>
            <el-table-column prop="Date" label="Paid Date" width="140"></el-table-column>
            <el-table-column label="Actions" width="100" align="right">
                <template slot-scope="scope">
                    <a :href="scope.row.links.pdf.href" target="_blank">PDF</a>
                    <span>|</span>
                    <a @click="showSendMail(scope.row)">Send</a>
                </template>
            </el-table-column>
        </el-table>
        <modal-send-mail @send="onSendMail" ref="sendMail"/>
    </el-dialog>
</template>

<style scoped>

</style>